// extracted by mini-css-extract-plugin
module.exports = {"container":"dk","disabled":"ek","bgBlack":"fk","content":"gk","countdown":"hk","topCaption":"ik","topHeading":"jk","heading":"kk","copy":"lk"};